import { Loader2 } from 'lucide-react';
import { useState } from 'react';
import { FcGoogle } from 'react-icons/fc';
import { AuthScreen } from './AuthScreen';
import { useAuth } from './AuthContext';
import { EmailPasswordForm } from './EmailPasswordForm';

/** Full-screen sign-in shown to unauthenticated visitors. */
export function SignInScreen() {
  const { signInWithGoogle } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSignIn() {
    setError(null);
    setBusy(true);
    try {
      await signInWithGoogle();
    } catch (e) {
      // Ignore the user simply closing the popup; surface anything else.
      const code = (e as { code?: string }).code;
      if (code !== 'auth/popup-closed-by-user' && code !== 'auth/cancelled-popup-request') {
        setError('Sign-in failed. Please try again.');
        console.error(e);
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthScreen>
      <div className='tw:w-full tw:max-w-sm'>
        <button
          type='button'
          onClick={handleSignIn}
          disabled={busy}
          aria-busy={busy || undefined}
          className='tw:inline-flex tw:w-full tw:items-center tw:justify-center tw:gap-3 tw:rounded tw:bg-white tw:px-6 tw:py-3 tw:text-sm tw:font-medium tw:text-ed-black tw:transition-opacity tw:hover:opacity-90 tw:disabled:opacity-60'
        >
          {busy ? <Loader2 className='tw:size-5 tw:animate-spin' /> : <FcGoogle className='tw:size-5' />}
          {busy ? 'Signing in…' : 'Sign in with Google'}
        </button>

        <EmailPasswordForm mode='sign-in' disabled={busy} onError={setError} />
      </div>

      <p className='tw:mt-8 tw:max-w-sm tw:text-xs tw:text-white/50'>
        Access is limited to Eighty Days administrators and our partners. Partners: use the invitation
        link you were sent to create your account.
      </p>
      {error && <p className='tw:mt-4 tw:text-sm tw:text-ed-red'>{error}</p>}
    </AuthScreen>
  );
}
